import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import "antd/dist/antd.css";
import { Redirect, withRouter } from "react-router-dom";

class FindSetup extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            initialised: false,
        };
    }

    getQueryParams = () => {
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        return params;
    };

    createFullFindLink = () => {
        const path = this.props.location.pathname;
        const query = this.props.location.search;
        const hostname = window.location.protocol + "//" + window.location.host;

        const url = `${hostname}${path}${query}`;
        return url;
    };

    render() {
        let searchType = null;
        let paramOne = null;
        let paramTwo = null;
        let paramThree = null;
        let filterParams = {};
        let autoplay = false;
        let targetInspection = false;

        if (this.props.match.params.type) {
            searchType = this.props.match.params.type;
            paramOne = this.props.match.params.param1;
            paramTwo = this.props.match.params.param2;
            paramThree = this.props.match.params.param3;
            const queryParams = this.getQueryParams();

            autoplay = queryParams.get("autoplay") === "1";
            targetInspection = queryParams.get("inspection") === "1";

            let timestamp = queryParams.get("timestamp");

            if (typeof timestamp === "string") {
                timestamp = parseFloat(timestamp);
            }

            filterParams = {
                timestamp,
                deviceKey: queryParams.get("device_key"),
                track_id: queryParams.get("track_id"),
                start_ts: queryParams.get("start_ts"),
                end_ts: queryParams.get("end_ts"),
                tags: queryParams.get("tags"),
                workspace: queryParams.get("workspace"),
            };

            if (this.props.match.params.type === "pulse") {
                filterParams = {
                    elr: queryParams.get("elr"),
                    mile: queryParams.get("mile"),
                    yard: queryParams.get("yard"),
                };
            }
        }

        if (!this.props.access_token) {
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: {
                            from: this.props.location,
                            searchType,
                            paramOne,
                            paramTwo,
                            paramThree,
                            filterParams,
                        },
                    }}
                />
            );
        } else {
            return (
                <Redirect
                    to={{
                        pathname: "/",
                        state: {
                            searchType,
                            paramOne,
                            paramTwo,
                            paramThree,
                            filterParams,
                            autoplay,
                            inspection: targetInspection,
                            findLink: this.createFullFindLink(),
                        },
                    }}
                />
            );
        }
    }
}

const mapStateToProps = (state) => {
    return { access_token: state.access_token, userEmail: _.get(state.userDetails, "email", "unknown email") };
};

export default connect(mapStateToProps)(withRouter(FindSetup));
